import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class EmailConstrain
 * Validiert E-Mail-Adressen analog zur serverseitigen EmailConstrain.php.
 * Leere Werte werden akzeptiert — Pflichtfeld-Prüfung obliegt NotBlankConstrain.
 */
class EmailConstrain extends ConstrainBase {

  // Gespiegelt von EmailConstrain.php::PATTERN
  static PATTERN = /^[A-Za-zÄÖÜäöü0-9.!#$%&'*+\-/=?^_`{|}~]+@[A-Za-zÄÖÜäöü0-9.!#$%&'*+\-/=?^_`{|}~]+\.[A-Za-z]{2,}$/;

  constructor(message = 'Email ist ungültig!') {
    super();
    this.message = message;
  }

  validate(value) {
    if (value === null || value === undefined || value === '') {
      return new ValidationResult(true, '');
    }
    if (!EmailConstrain.PATTERN.test(String(value))) {
      return new ValidationResult(false, this.message);
    }
    return new ValidationResult(true, '');
  }
}

export default EmailConstrain;
